import { Component, OnInit } from "@angular/core";
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { EmployeEntite } from '../entites/employe';
import { DonneesBaseService } from '../services/donnees-base-service';
import { MessageService } from "primeng/api";
import { Router } from "@angular/router";

export interface ParametresSelectionDestinatairesRapportSST {
    destinatairesParDefaut: EmployeEntite[];
    emplacementId: number;
}

@Component({
    templateUrl: './selection-destinataires-rapport-sst.component.html',
    styles: [`
        :host ::ng-deep .p-chips-multiple-container {
            width: 100%;
        }
    `]
})
export class SelectionDestinatairesRapportSSTComponent implements OnInit {
    employes: EmployeEntite[] = [];
    selection: EmployeEntite[] = [];
    autreCourriels: string[] = [];
    emplacementId: number;

    constructor(
        public sdb: DonneesBaseService,
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        public messageService: MessageService,
        private router: Router
    ) { }

    ngOnInit() {
        const donnees: ParametresSelectionDestinatairesRapportSST = this.config.data;
        this.employes = donnees.destinatairesParDefaut;
        this.emplacementId = donnees.emplacementId;
        this.selection = [...this.employes];
    }

    Envoyer() {
        if (this.selection.length === 0) {
            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Veuillez sélectionner au moins un destinataire.' });
            return;
        }

        this.ref.close([...this.selection.map(emp => emp.courriel), ...this.autreCourriels]);
    }

    Annuler() {
        this.ref.close(null);
    }

    allerDansEmplacement() {
        this.router.navigate(['/emplacement', this.emplacementId], { queryParams: { tab: '2' } });
        this.ref.close();
    }
} 